import http from './http';

const transformRequest = (jsonData = {}) => Object.entries(jsonData)
    .map(x => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
    .join('&');

export default {
    login({ username, password }) {
        const request = {
            username,
            password,
            grant_type: 'password',
        };

        return http.post('/auth', transformRequest(request), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        });
    },
    refreshToken(token) {
        const request = {
            refresh_token: token,
            grant_type: 'refresh_token',
        };

        return http.post('/auth', transformRequest(request), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        });
    },
    getSelf() {
        return http.get('/user/getself');
    },
};
